import { render, staticRenderFns } from "./cadconferencias.vue?vue&type=template&id=4ec16923&"
import script from "./cadconferencias.vue?vue&type=script&lang=js&"
export * from "./cadconferencias.vue?vue&type=script&lang=js&"
import style0 from "./cadconferencias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports